'use client'

import dynamic from 'next/dynamic'
import { Fragment, useEffect, useMemo, useState } from 'react'

import { Loading } from '@/components/atoms/icons'

import { formatString } from '@/lib/utils/format-string'

import { LayananTestimonial } from './layanan-testimonial'

const LayananFAQ = dynamic(() => import('@/components/organisms/layanan/layanan-faq').then((mod) => mod.LayananFAQ))
const LayananHero = dynamic(() => import('@/components/organisms/layanan/layanan-hero').then((mod) => mod.LayananHero))
const LayananList = dynamic(() => import('@/components/organisms/layanan/layanan-list').then((mod) => mod.LayananList), {
  loading: () => (
    <div className="flex items-center justify-center w-full h-[40vh]">
      <Loading className="w-9 h-9 text-primary-blue" />
    </div>
  )
})

interface LayananProps {
  data: Service
  testimonial: Testimonial
  categoryList?: string[]
  params: Params
}

export const Layanan = ({ data, testimonial, categoryList, params }: LayananProps) => {
  const tabList = useMemo(() => {
    if (!data?.items) return []

    const serviceTabIds = data.items.flatMap((item) => item.fields.serviceTab?.map((tab) => tab.sys.id) ?? [])
    const idToIndex = new Map(serviceTabIds.map((id, index) => [id, index]))

    return data?.includes?.Entry?.filter((entry) => idToIndex.has(entry.sys.id)).sort(
      (a, b) => (idToIndex.get(a.sys.id) ?? -1) - (idToIndex.get(b.sys.id) ?? -1)
    )
  }, [data])

  const [activeTab, setActiveTab] = useState(params.tab ?? formatString(tabList?.[0]?.fields?.title))

  useEffect(() => {
    params.tab && setActiveTab(params.tab as string)
  }, [params, setActiveTab])

  return (
    <Fragment>
      <LayananHero title={data.items[0].fields.title} description={data.items[0].fields.description} />
      <LayananList
        activeTab={activeTab as string}
        setActiveTab={setActiveTab}
        tabActive
        data={data}
        tabList={tabList}
        categoryList={categoryList as string[]}
        activeCat={params.category ?? 'semua'}
      />
      {testimonial?.items[0]?.fields?.testimonialShow === true && (
        <LayananTestimonial data={testimonial} testimonialVideo={testimonial?.items[0]?.fields?.testimonialVideo ?? false} />
      )}
      <LayananFAQ data={data} activeTab={activeTab} />
    </Fragment>
  )
}
